<template>
  <div class="home__entry">
    <img class="home__entry--background" src="https://notaireleveillee.s3.ca-central-1.amazonaws.com/assets/asset2.jpg" alt="Notaire outremont">
    <div class="home__entry--title">
      <h1>{{ $t("homeTranslate.homeEntryTitle") }}</h1>
      <p>{{ $t("homeTranslate.homeEntrySubtitle") }}</p>
    </div>
    <div class="home__entry--motto">
      <p>{{ $t("homeTranslate.motto") }}</p>
      <img src="https://notaireleveillee.s3.ca-central-1.amazonaws.com/assets/chambre-notaire.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'home-entry',
  data () {
    return {
      locale: 'en'
    }
  },
  watch: {
    locale (val) {
      this.$i18n.locale = val
    }
  }
}
</script>

<style lang="css">
</style>
